import React from "react"
import {formatPercentage, formatPrice} from "ui-seeker/utils";
import {useAppCalendarCellContent} from "./@hooks";

export default function AppCalendarCellContent({ date, main, compset, openDetailsModal }) {
    const {
        comp, price, colorComp,
        currency, percentComp,
    } = useAppCalendarCellContent(main, compset)

    return <div
        className="CalendarDayComp"
        style={{
            cursor: "pointer",
            transition: 'all 0.2s ease-in-out',
            transformOrigin: 'center center',
            willChange: 'transform, filter'
        }}
        onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.filter = 'brightness(0.95)';
        }}
        onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.filter = 'brightness(1)';
        }}
        onClick={() => openDetailsModal({
            showModalDay: true,
            infoDay: {
                main,
                compset,
                date
            }
        })}>
        <div className={`price text-white ${colorComp}`}>
            <span className="px-8">
                { main?.na
                    ? (main.cause === 'sold-out' ? 'SOLD OUT' : (main.cause === 'no-data' ? '-' : main.cause))
                    : formatPrice(price, { currency })
                }
            </span>
        </div>
        <div className={`comp text-white ${colorComp}-light`}>
            <span>Comp</span>
            <span style={{ minWidth: '80px' }}>{formatPrice(comp, {currency})}</span>
            <span>{price ? formatPercentage(percentComp) : '-'}</span>
        </div>
    </div>
}